import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "incident-table"
};
const _hoisted_2 = ["href"];
import { ref, onMounted, toRefs, watch } from 'vue';
import { mctRequest } from '@/api/axios';
import { storeToRefs } from 'pinia';
import { useDetailStatusStore } from '@/store/detailStatus';
export default /*@__PURE__*/_defineComponent({
  __name: 'IncidentTable',
  props: {
    serverId: {}
  },
  setup(__props) {
    const detailStatusStore = useDetailStatusStore();
    const {
      snowStatus,
      refreshIncidentTable
    } = storeToRefs(detailStatusStore);
    const props = __props;
    const {
      serverId
    } = toRefs(props);
    const tableData = ref([]);
    // @ts-ignore
    const snowIncidentSite = ref(window.envConfig?.snowIncidentSite);
    const getIncident = async () => {
      tableData.value = [];
      const config = {
        url: `/incident?serverId=${serverId.value}`
      };
      const {
        incident,
        status
      } = await mctRequest.request(config);
      tableData.value = incident;
      //1-remedy;2-remedy&snow;3-snow
      snowStatus.value = status || '1';
    };
    onMounted(() => {
      getIncident();
    });
    watch(refreshIncidentTable, () => {
      getIncident();
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_table, {
        data: tableData.value,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "incidentId",
          label: "Incident ID"
        }, {
          default: _withCtx(scope => [_createElementVNode("a", {
            href: snowIncidentSite.value + scope.row.incidentId,
            class: "mct-blue",
            target: "_blank"
          }, _toDisplayString(scope.row.incidentId), 9, _hoisted_2)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "summary",
          label: "Summary",
          width: "400"
        }), _createVNode(_component_el_table_column, {
          prop: "userName",
          label: "Submitter"
        }), _createVNode(_component_el_table_column, {
          prop: "submitTime",
          label: "Date"
        })]),
        _: 1
      }, 8, ["data"])]);
    };
  }
});